const checkScreenMode = Variables => {
  if (Variables.SWITCH_SCREEN_MODE === false) {
    return true;
  } else {
    return false;
  }
};

export default checkScreenMode;
